import { render, staticRenderFns } from "./admin-off.vue?vue&type=template&id=43d93daa&"
import script from "./admin-off.vue?vue&type=script&lang=js&"
export * from "./admin-off.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports